<template>
    <div>
        <input class="inp" type="text" v-model="min" @keyup="checkNumber" />
        <div class="divider">to</div>
        <input class="inp min" type="text" v-model="max" @keyup="checkNumber" />
    </div>
</template>

<script>
export default {
    name: "MinMaxInput",
    event: "input",
    props: {
        value: {
            type: Array,
            default: () => [0, 0],
        },
    },
    data() {
        return {
            min: 0,
            max: 0
        };
    },
    created() {
        this.min = this.value[0];
        this.max = this.value[1];
    },
    methods: {
        checkNumber(event) {
            //allow backspace, tab, delete, arrows, numbers and keypad numbers ONLY
            if (
                [46, 8, 9, 27, 13, 110, 190].indexOf(event.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (event.keyCode == 65 && event.ctrlKey === true) ||
                // Allow: Ctrl+C
                (event.keyCode == 67 && event.ctrlKey === true) ||
                // Allow: Ctrl+X
                (event.keyCode == 88 && event.ctrlKey === true) ||
                // Allow: home, end, left, right
                (event.keyCode >= 35 && event.keyCode <= 39)
            ) {
                // let it happen, don't do anything
                return;
            }
            //allow dot
            if (event.keyCode == 110 || event.keyCode == 190 || event.keyCode == 191) {
                return;
            }
             //allow dash
            if (event.keyCode == 189) {
                return;
            }
            if (!(event.keyCode >= 48 && event.keyCode <= 57) && !(event.keyCode >= 96 && event.keyCode <= 105)) {
                event.preventDefault();
            }
            this.$emit("input", [Number(this.min), Number(this.max)]);
        }
    }
};
</script>

<style scoped>
.inp {
    text-align: right;
    width: 75px;
    float: left;
    padding: 10px;
    border: 1px solid #d8d8d8;
    border-radius: 5px 0px 0px 5px;
}

.inp.min {
    text-align: left;
    border-radius: 0px 5px 5px 0px;
}

.divider {
    height: 100%;
    padding-left: 15px;
    padding-right: 15px;
    line-height: 37px;
    float: left;
    background-color: #d8d8d8;
}

.inp:focus {
    outline: none;
}
</style>

